import { ActivityResponse } from '~teacher/hook';
import { Student } from '~teacher/models/activities';

const findByName =
  (name: string) =>
  ([, student]: [studentId: string, student: Student]) =>
    student.name === name;

const findByUuid =
  (uuid: string) =>
  ([, student]: [studentId: string, student: Student]) =>
    student.userUuid === uuid;

export const findStudentIdByUuid = (
  activityData: ActivityResponse,
  userUuid: string
) => createFindBy(activityData, findByUuid(userUuid));

export const findStudentIdByName = (
  activityData: ActivityResponse,
  name: string
) => createFindBy(activityData, findByName(name));

function createFindBy(
  { students = {} }: ActivityResponse,
  findFunction: (item: [studentId: string, student: Student]) => boolean
) {
  const [studentId] = Object.entries<Student>(students).find(findFunction) ?? [
    null,
    null,
  ];

  return studentId;
}
